import React from "react";
import { hasAnyPrivilege } from "../../utils/privileges";

const NoAccess = () => (
  <div className="flex flex-col items-center justify-center h-[60vh] text-center">
    <i className="bi bi-shield-lock text-5xl text-gray-300 mb-4"></i>
    <h3 className="text-lg font-semibold text-gray600 mb-1">
      You don't have access to this page
    </h3>
    <p className="text-gray400 text-sm">
      Contact your administrator if you think this is a mistake.
    </p>
  </div>
);

// Wraps a route element and only renders it if the current user holds at
// least one of the given privilege slugs. This is a UX convenience, not a
// security boundary — the real access control still has to happen server-side.
// An empty/omitted `privileges` array means the route is intentionally ungated.
const PrivilegeGate = ({ privileges = [], children }) => {
  return hasAnyPrivilege(privileges) ? children : <NoAccess />;
};

export default PrivilegeGate;
